"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FaceVeryHappyOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FaceVeryHappyOutlineSVG = function FaceVeryHappyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm0,2A12,12,0,1,0,28,16,12,12,0,0,0,16,4Zm6.08,13.43a1,1,0,0,1,1,1c0,3.07-3.39,6.13-7.08,6.13S8.92,21.5,8.92,18.43a1,1,0,0,1,1-1H22.08Zm-1.21,2H11.13l0,.14a5.57,5.57,0,0,0,4.6,3H16a5.55,5.55,0,0,0,4.82-3h0ZM12,11a2,2,0,1,1-2,2A2,2,0,0,1,12,11Zm8,0a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z"
  }));
};
exports.FaceVeryHappyOutlineSVG = FaceVeryHappyOutlineSVG;
FaceVeryHappyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FaceVeryHappyOutlineSVG);
exports.default = _default;